import React from "react";
import './skeleton.css'

const KeywordSkeleton = ({ count = 10, direction = 'row', width = '100%'}) => {
  const skeletons = Array.from({ length: count });

  return (
    <div className="row">
      {skeletons.map((_, index) => (
        <div className={`${direction ===  'row' ?  "col-md-4" : "col-md-12"}`} key={index}>
          <div
            className="flex items-center"
            style={{ display: "flex",  gap: "5px", width:width, alignItems: "center", marginBottom: "0.5rem" }}
          >
            <div
              className="skeleton-checkbox"
              style={{
                width: "16px",
                height: "16px",
                backgroundColor: "#e0e0e0",
                borderRadius: "3px"
              }}
            ></div>
            <div
              className="skeleton-label"
              style={{
                height: "14px",
                width: "80%",
                backgroundColor: "#e0e0e0",
                borderRadius: "4px"
              }}
            ></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default KeywordSkeleton;
